<template lang="pug">
    .eventsGrid.clearfix(ref="eventsGrid")
        slot
</template>

<script>
    export default {
        name: "EventsGrid",
        methods:{
            initGrid(){
                this.$refs.eventsGrid.setAttribute('data-count', this.$refs.eventsGrid.children.length)
            }
        },
        updated() {
            this.initGrid();
        },
        mounted() {
            this.initGrid();
        }
    }
</script>

<style scoped lang="scss">
    .eventsGrid{
        width: calc(100% + 1.5rem);
        margin-right: -1.5rem;
        & > a{
            display: block;
            float: left;
            margin-bottom: 1.5rem;
            margin-right: 1.5rem;
            width: calc(100% - 1.5rem);
            height: calc(33.8rem - 2px);
            &.medium{
                width: calc(50% - 1.5rem);
            }
            &.small{
                width: calc(50% - 1.5rem);
                height: calc((33.8rem - 1.5rem) / 2);
            }
        }
        &[data-count="1"] > a{
            &:nth-of-type(1){
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
            }
            }
        }
        &[data-count="2"] > a{
            &:nth-of-type(1), &:nth-of-type(2){
                width: calc(50% - 1.5rem);
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                        max-width: 50%;
                    }
                    p {max-width: 50%} }
            }
        }
        &[data-count="3"] > a{
            &:nth-of-type(1){
                width: calc(50% - 1.5rem);
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                        max-width: 50%;
                    }
                    p {max-width: 50%} }
            }
            &:nth-of-type(2), &:nth-of-type(3){
                width: calc(50% - 1.5rem);
                height: calc((33.8rem - 1.5rem) / 2);
                &::v-deep {
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 2;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                    .text{
                        display: block;
                        p {
                            -ms-text-overflow: ellipsis;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            -ms-line-clamp: 3;
                            -webkit-line-clamp: 3;
                            line-clamp: 3;
                            display: -webkit-box;
                            display: box;
                            word-wrap: break-word;
                            -webkit-box-orient: vertical;
                            box-orient: vertical;
                        }
                    }
                }

            }
        }
        &[data-count="4"] > a{
            &:nth-of-type(1){
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                }
            }
            &:nth-of-type(2){
                width: calc(50% - 1.5rem);
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                        max-width: 50%;
                    }
                    p {max-width: 50%} }
            }
            &:nth-of-type(3), &:nth-of-type(4){
                width: calc(50% - 1.5rem);
                height: calc((33.8rem - 1.5rem) / 2);
                &::v-deep {
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 2;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                    .text{
                        display: block;
                        p {
                            -ms-text-overflow: ellipsis;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            -ms-line-clamp: 3;
                            -webkit-line-clamp: 3;
                            line-clamp: 3;
                            display: -webkit-box;
                            display: box;
                            word-wrap: break-word;
                            -webkit-box-orient: vertical;
                            box-orient: vertical;
                        }
                    }
                }
            }
        }
        &[data-count="5"] > a{
            &:nth-of-type(1){
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                }
            }
            &:nth-of-type(2), &:nth-of-type(3), &:nth-of-type(4), &:nth-of-type(5){
                width: calc(50% - 1.5rem);
                height: calc((33.8rem - 1.5rem) / 2);
                &::v-deep {
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 2;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                    .text{
                        display: block;
                        p {
                            -ms-text-overflow: ellipsis;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            -ms-line-clamp: 3;
                            -webkit-line-clamp: 3;
                            line-clamp: 3;
                            display: -webkit-box;
                            display: box;
                            word-wrap: break-word;
                            -webkit-box-orient: vertical;
                            box-orient: vertical;
                        }
                    }
                }

            }
        }
        &[data-count="6"] > a{
            &:nth-of-type(1), &:nth-of-type(4){
                width: calc(50% - 1.5rem);
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                        max-width: 50%;
                    }
                    p {max-width: 50%} }
            }
            &:nth-of-type(2),  &:nth-of-type(3), &:nth-of-type(5), &:nth-of-type(6){
                width: calc(50% - 1.5rem);
                height: calc((33.8rem - 1.5rem) / 2);
                &::v-deep {
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 2;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                    .text{
                        display: block;
                        p {
                            -ms-text-overflow: ellipsis;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            -ms-line-clamp: 3;
                            -webkit-line-clamp: 3;
                            line-clamp: 3;
                            display: -webkit-box;
                            display: box;
                            word-wrap: break-word;
                            -webkit-box-orient: vertical;
                            box-orient: vertical;
                        }
                    }
                }
            }
            &:nth-of-type(4),  &:nth-of-type(5), &:nth-of-type(6){
                float: right;
            }
        }
        &[data-count="7"] > a{
            &:nth-of-type(1){
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                }
            }
            &:nth-of-type(2), &:nth-of-type(5){
                width: calc(50% - 1.5rem);
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                        max-width: 50%;
                    }
                    p {max-width: 50%} }
            }
            &:nth-of-type(3),  &:nth-of-type(4), &:nth-of-type(6), &:nth-of-type(7){
                width: calc(50% - 1.5rem);
                height: calc((33.8rem - 1.5rem) / 2);
                &::v-deep {
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 2;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                    .text{
                        display: block;
                        p {
                            -ms-text-overflow: ellipsis;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            -ms-line-clamp: 3;
                            -webkit-line-clamp: 3;
                            line-clamp: 3;
                            display: -webkit-box;
                            display: box;
                            word-wrap: break-word;
                            -webkit-box-orient: vertical;
                            box-orient: vertical;
                        }
                    }
                }
            }
            &:nth-of-type(5), &:nth-of-type(6), &:nth-of-type(7){
                float: right;
            }
        }
        &[data-count="8"] > a{
            &:nth-of-type(2){
                width: calc(50% - 1.5rem);
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                        max-width: 50%;
                    }
                    p {max-width: 50%} }
            }
            &:nth-of-type(3),  &:nth-of-type(4), &:nth-of-type(5), &:nth-of-type(6), &:nth-of-type(7), &:nth-of-type(8){
                width: calc(50% - 1.5rem);
                height: calc((33.8rem - 1.5rem) / 2);
                &::v-deep {
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 2;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                    .text{
                        display: block;
                        p {
                            -ms-text-overflow: ellipsis;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            -ms-line-clamp: 3;
                            -webkit-line-clamp: 3;
                            line-clamp: 3;
                            display: -webkit-box;
                            display: box;
                            word-wrap: break-word;
                            -webkit-box-orient: vertical;
                            box-orient: vertical;
                        }
                    }
                }
            }
        }
        &[data-count="9"] > a{
            &:nth-of-type(1){
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                }
            }
            &:nth-of-type(2), &:nth-of-type(5){
                width: calc(50% - 1.5rem);
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                        max-width: 50%;
                    }
                    p {max-width: 50%} }
            }
            &:nth-of-type(3),  &:nth-of-type(4), &:nth-of-type(6), &:nth-of-type(7), &:nth-of-type(8), &:nth-of-type(9){
                width: calc(50% - 1.5rem);
                height: calc((33.8rem - 1.5rem) / 2);
                &::v-deep {
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 2;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                    .text{
                        display: block;
                        p {
                            -ms-text-overflow: ellipsis;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            -ms-line-clamp: 3;
                            -webkit-line-clamp: 3;
                            line-clamp: 3;
                            display: -webkit-box;
                            display: box;
                            word-wrap: break-word;
                            -webkit-box-orient: vertical;
                            box-orient: vertical;
                        }
                    }
                }
            }
            &:nth-of-type(5), &:nth-of-type(6), &:nth-of-type(7){
                float: right;
            }
        }
        &[data-count="10"] > a{
            &:nth-of-type(1){
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                }
            }
            &:nth-of-type(2), &:nth-of-type(5), &:nth-of-type(8){
                width: calc(50% - 1.5rem);
                &::v-deep{
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 4;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                        max-width: 50%;
                    }
                    p {max-width: 50%} }
            }
            &:nth-of-type(3),  &:nth-of-type(4), &:nth-of-type(6), &:nth-of-type(7), &:nth-of-type(9), &:nth-of-type(10){
                width: calc(50% - 1.5rem);
                height: calc((33.8rem - 1.5rem) / 2);
                &::v-deep {
                    h3 {
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -ms-line-clamp: 2;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        display: -webkit-box;
                        display: box;
                        word-wrap: break-word;
                        -webkit-box-orient: vertical;
                        box-orient: vertical;
                    }
                    .text{
                        display: block;
                        p {
                            -ms-text-overflow: ellipsis;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            -ms-line-clamp: 3;
                            -webkit-line-clamp: 3;
                            line-clamp: 3;
                            display: -webkit-box;
                            display: box;
                            word-wrap: break-word;
                            -webkit-box-orient: vertical;
                            box-orient: vertical;
                        }
                    }
                }
            }
            &:nth-of-type(5), &:nth-of-type(6), &:nth-of-type(7){
                float: right;
            }
        }
        @include mobile_or_P{
            width: 100%;
            margin-right: 0;
            &::v-deep{ h3, p{max-width: 100% !important;} }
            a{
                width: 100% !important;
                height: auto !important;
                margin-bottom: 1.2rem;
                margin-right: 0;
            }
        }
    }
</style>
